import React from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';

import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import ForgotPasswordForm from '../../components/public/ForgotPasswordForm.component';
import { PUBLIC_AUTHENTICATION_APP_PATHS } from '../../constants/authentication-paths.constants';
import { PUBLIC_PANELS } from '../../../shared/public/constants/panel.constants';

const PANEL_ROUTES: Record<string, string> = {
  [PUBLIC_PANELS.LOGIN]: PUBLIC_AUTHENTICATION_APP_PATHS.LOGIN,
};

const useStyles = makeStyles((theme) => ({
  wrapper: { display: 'flex', justifyContent: 'center', padding: theme.spacing(6, 3) },
  column: { width: '100%', maxWidth: 440 },
  title: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    marginBottom: theme.spacing(3),
    color: theme.palette.client.primary.extraDark,
  },
}));

const ForgotPasswordView: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  const onNavigate = (panel: string) => history.push(PANEL_ROUTES[panel] ?? PUBLIC_AUTHENTICATION_APP_PATHS.LOGIN);

  return (
    <React.Fragment>
      <Helmet>
        <title>Mot de passe oublié - Bio Culture</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className={classes.wrapper}>
        <div className={classes.column}>
          <Typography variant="h4" component="h1" className={classes.title}>
            Mot de passe oublié
          </Typography>

          <ForgotPasswordForm onNavigate={onNavigate} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ForgotPasswordView;
